import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { ModelBroker } from '../dashboard/Models';
import { CoolWriteStore } from '../packages/voting/VotingViewState';
import { createScope } from '../Scope';

const modelTemplate = {
    autoJoinEnabled: false,
    autoJoinWhitelist: '',
};

export class ManageUserAccessControlModel extends CoolWriteStore(modelTemplate) {

    public readonly id = '$';

    public static create(_broker: ModelBroker) {
        return new ManageUserAccessControlModel();
    }

    public format() {
        this.mutate(u => {
            u.autoJoinWhitelist = (u.autoJoinWhitelist ?? '').split(/[,;\s]/g)
                .map(x => x.trim().toLowerCase())
                .filter(x => !!x)
                .map(x => x.includes('@') ? x : `*@${x}`)
                .map(x => x.startsWith('@') ? `*${x}` : x)
                .join('\r\n');
        });
    }
}

export const ManageUserAccessControlScope = createScope({
    async refresh(p, c) {
        const api = c.get(ApiClient);
        const broker = c.get(ModelBroker);

        const data = await api.exec(v2.admin.accessControl.info());
        const model = broker.allocate(ManageUserAccessControlModel);
        model.updateTo(data);

        c.bind(ManageUserAccessControlModel).toConstantValue(model);

        return [
        ];
    }
});
